import { IsNotEmpty, IsString, IsUUID } from 'class-validator';

export class UserGlucoseSourceParamsDto {
  @IsUUID()
  public id!: string;

  @IsString()
  @IsNotEmpty()
  public sourceId!: string;
}
